<template>
	<inertia-head title="Win a Coffee Session with Bro. Bo Sanchez! " />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					
					<h1 class="fw-bold text-white mb-2">
						How Financially Fit Are You? (Philippine Edition)
					</h1>
					<!-- <h3 class="fw-bold text-white mb-2">Plus other exciting prizes!</h3> -->
					<!-- <h4 class="fw-normal text-white-75 fs-sm">
						Register your details belo
					</h4> -->
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="row">
			<div class="col-sm-12 col-md-5 col-lg-5">
				<img src="/media/images/feastcon25.jpg" alt="" class="img-fluid mb-2">
			</div>
			<div class="col-sm-12 col-md-7 col-lg-7">
				<h2 class="text-center">Fill out the details below!</h2>
				<h4 class="text-center">You'll receive a QR Code from us, which you'll need to show to our team at the Truly Rich Club Booth to get a chance to spin!</h4>
				<h1 class="text-center"><i class="fa fa-arrow-down"></i></h1>
				<div class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<div v-if="!details_done" id="details_content">
							<div class="form-group mb-3">
								<label>First Name</label>
								<input type="text" v-model="form.fname" name="fname" class="form-control" />
								<span v-if="form.errors.fname" class="text-danger">{{form.errors.fname}}</span>
							</div>
							<div class="form-group mb-3">
								<label>Last Name</label>
								<input type="text" v-model="form.lname" name="lname" class="form-control" />
								<span v-if="form.errors.lname" class="text-danger">{{form.errors.lname}}</span>
							</div>
							<div class="form-group mb-3">
								<label>Email Address</label>
								<input type="text" v-model="form.email" name="email" class="form-control" />
								<span v-if="form.errors.email" class="text-danger">{{form.errors.email}}</span>
							</div>
							<div class="form-group mb-3">
								<label>Mobile</label>
								<vue-tel-input
									@input="onInput"
									@countryChanged="onCountryChange"
									v-model="form.mobile"
									:value="form.mobile"
									class="form-control"
									:class="{ 'is-invalid': form.errors.mobile }"
									:input-options="{
										placeholder: 'Enter mobile number',
									}"
									:defaultCountry="form.country_code"
									mode="international"
								/>
								<span v-if="form.errors.mobile" class="text-danger">{{form.errors.mobile}}</span>
							</div>
						</div>
						<div v-if="details_done" id="quiz_content">
							<div>
								<p>Instructions: Answer each question honestly and give yourself the corresponding score. At the end, add up your total to see your financial fitness level.</p>
							</div>
							<div v-for="q,q_index in quiz" class="form-group mb-4">
								<label class="fw-semibold mb-2">{{q.question}}</label>
								<div class="form-check mb-2">
									<input @change="checkAnswer" type="radio" v-model="form.quiz[q_index].ans_pts" :id="'ans1_'+q_index" :name="'ans_'+q_index" :value="q.ans1_pts">
									<label class="form-check-label bg-alt-primary ms-1" :for="'ans1_'+q_index">{{q.ans1}}</label>
								</div>
								<div class="form-check mb-2">
									<input @change="checkAnswer" type="radio" v-model="form.quiz[q_index].ans_pts" :id="'ans2_'+q_index" :name="'ans_'+q_index" :value="q.ans2_pts">
									<label class="form-check-label bg-alt-primary ms-1" :for="'ans2_'+q_index">{{q.ans2}}</label>
								</div>
								<div class="form-check mb-2">
									<input @change="checkAnswer" type="radio" v-model="form.quiz[q_index].ans_pts" :id="'ans3_'+q_index" :name="'ans_'+q_index" :value="q.ans3_pts">
									<label class="form-check-label bg-alt-primary ms-1" :for="'ans3_'+q_index">{{q.ans3}}</label>
								</div>
							</div>
						</div>

						<div class="form-group mt-4 text-center">
							<button v-if="!details_done" @click="checkDetails" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-arrow-right me-1"></i>
								Next Process
							</button>

							<button v-else @click="claimBook" type="button" class="btn btn-success btn-lg" :disabled="!quiz_done || form.processing">
								<div
									v-if="form.processing"
									class="spinner-border spinner-border-sm text-white me-1"
									role="status"
								>
									<span class="sr-only">Loading...</span>
								</div>
								<i v-else class="fa fa-envelope me-1"></i>
								Complete Now!
							</button>
						</div>
						
					</div>
				</div>

				<div class="block-content block-content-full">
					<p class="text-gray-dark">Disclaimer:
						By subscribing to our newsletter, you'll stay updated on our latest offerings, special promotions, and valuable content. Your email address is safe with us, and we will never share it with others. If you ever wish to unsubscribe, you 
			can do so easily at any time. Thank you for joining our community and being a part of our financial freedom journey!</p>
				</div>

			</div>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/FreeBookLayout';
	import { watch, ref, onMounted } from 'vue'
	import { useForm } from '@inertiajs/inertia-vue3'
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			event_year 		: String,
			quiz 			: Object,
			flash 			: Object,
		},
		mounted(){
			if(this.quiz)
			{
				for (var i = 0; i < this.quiz.length; i++) {
					let quiz = this.quiz[i];
					this.form.quiz.push({
						event_year 			: quiz.event_year,
						feastcon_quiz_id 	: quiz.feastcon_quiz_id,
						ans_pts 			: null,
					});
				}
				
			}
		},
		setup(props){

			const details_done 	= ref(false);
			const quiz_done 	= ref(false);

			const form = useForm({
				year_claim 	: props.event_year,
				fname 		: '',
				lname 		: '',
				email 		: '',
				country_calling_code: '63',
				country_code: '',
				mobile		: '',
				quiz 		:[]
			})

			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				if(phoneObject.formatted=='')
				{
					form.mobile = '';
				}
			}

			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}


			const checkDetails = ()=>{
				form.post(route("post.feastcon-check-details"),{
					only:['flash,errors'],
					onSuccess:()=>{
						details_done.value = true;
					}
				});
			}

			const checkAnswer = ()=>{
				let is_done = true;
				for (var i = 0; i < form.quiz.length; i++) {

					let ans_pts = form.quiz[i].ans_pts;

					if(ans_pts==null)
					{
						is_done = false;
						break;
					}
				}

				if(is_done)
				{
					quiz_done.value = true;
				}
			}

			const claimBook = ()=>{
				form.post(route("post.feastcon"),{
					only:['flash,errors'],
					onSuccess:()=>{
						let flash = props.flash;
						if (flash && flash.toast) {
							if(flash.toast.type=='success')
							{
								Inertia.get("/c/feastcon/thankyou?id="+flash.toast.data);
							}
							
						}
					}
				});
			}

			// watch(
			// 	() => props.flash,
			// 	(flash) => {
			// 		if (flash && flash.toast) {
			// 			if(flash.toast.type=='success')
			// 			{
			// 				Inertia.get("/c/feastcon/thankyou");
			// 			}
						
			// 		}
			// 	}
			// )

			return {
				details_done,
				quiz_done,
				form,
				onInput,
				onCountryChange,
				checkDetails,
				checkAnswer,
				claimBook
			}

		}
	}
</script>